// boingTriggerAnimation.js
var BoingTriggerAnimation = pc.createScript('boingTriggerAnimation');

BoingTriggerAnimation.attributes.add('challengeType', { type: 'string' });

BoingTriggerAnimation.prototype.initialize = function () {

    BoingTriggerAnimation.instance = this;

    this.delay = 500;

    if (completeMatchStatus == true) {
        this.delay = 3500;
    }

    setTimeout(function () {

        BoingTriggerAnimation.instance.entity
            .tween(BoingTriggerAnimation.instance.entity.getLocalScale())
            .to(new pc.Vec3(1.3, 1.3, 1.3), 0.5, pc.SineOut)
            .yoyo(true)
            .repeat(2)
            .on('complete', function () { BoingTriggerAnimation.instance.triggerChallengeButton(); })
            .start();

    }, this.delay, this);
};

BoingTriggerAnimation.prototype.triggerChallengeButton = function() {

    var selectedChallengeButton;

    if (this.challengeType == "Win") {
        selectedChallengeButton = this.app.root.findByTag("challengeWinFriendsPanel")[0];
    }
    else if (this.challengeType == "Lose") {
        selectedChallengeButton = this.app.root.findByTag("challengeLoseFriendsPanel")[0];
    }
    else if (this.challengeType == "LoseOffer") {
        selectedChallengeButton = this.app.root.findByTag("challengeLoseOfferFriendsPanel")[0];
    }
    else if (this.challengeType == "Draw") {
        selectedChallengeButton = this.app.root.findByTag("challengeDrawFriendsPanel")[0];
    }
    else if (this.challengeType == "LoseExtraTime") {
        //challengeLoseExtraTimePanel
        selectedChallengeButton = this.app.root.findByTag("challengeLoseExtraTimePanel")[0];
    }
    selectedChallengeButton.script.scripts[0].enabled = true;
};


